<template>
  <head>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
    />
  </head>

  <div class="content">
    <div class="content-container">
      <div class="header">
        <div class="header-container">
          <div class="logo">
            <img class="logo-img" src="../assets/logo.png" />
          </div>
        </div>
      </div>

      <div class="page-content">
        <div class="page-card">
          <div class="card-header">
            <h1>Infraction Reports</h1>
            <div>
              <router-link :to="{ path: '/admin' }">
                <a class="back-btn">
                  <i class="fa-solid fa-arrow-left"></i>
                  <p style="margin-left: 0.25rem">Back</p>
                </a>
              </router-link>
            </div>
          </div>

          <div class="report-type">
            <router-link :to="{ path: '/view-reports/' }">
              <button class="button-left">Unapproved Reports</button>
            </router-link>
            <router-link :to="{ path: '/view-reports/approved' }">
              <button class="button-right active">Approved Reports</button>
            </router-link>
          </div>

          <div class="reports">
            <table>
              <tbody>
                <tr v-for="report in sortedReports" :key="report.id">
                  <td>
                    <span>{{
                      report.property +
                      " | " +
                      report.unit +
                      " | " +
                      report.date
                    }}</span>
                    <button @click="viewReport(report.id)" class="view-btn">
                      View Report
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      domain: process.env.VUE_APP_DOMAIN,
      reports: [], // Array to store reports
    };
  },
  mounted() {
    this.fetchReports();
  },
  computed: {
    sortedReports() {
      return this.reports.slice().sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
    },
  },
  methods: {
    fetchReports() {
      const userToken = localStorage.getItem("userToken");
      if (userToken) {
        axios
          .post(`${this.domain}/api/admin/reports/approved`, { userToken })
          .then((response) => {
            this.reports = response.data.reports;
          })
          .catch((error) => {
            console.error("Error fetching reports:", error);
          });
      } else {
        console.error("No user token found");
        // Handle the absence of token, e.g., redirect to login
      }
    },
    viewReport(reportId) {
      console.log("Viewing report:", reportId);
      this.$router.push(`/approved/${reportId}`);
    },
  },
};
</script>

<style>
.report-type {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.welcome h1 {
  text-align: left;
}

.reports {
  display: flex;
  flex-direction: column;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

td {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

th {
  background-color: #f2f2f2;
}

.view-btn {
  background-color: var(--csm-blue);
  color: white;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-btn:hover {
  background: #00689c;
  cursor: pointer;
}

.view-btn:active {
  background-color: #0484c4;
  transition: 0.1s;
}

.active {
  background: rgb(14, 103, 155);
}
</style>
